import { makeStyles } from '@material-ui/core';
import { colors, fonts } from 'theme';

export const useStyles = makeStyles({
  dialogMessage: {
    fontWeight: 'bold',
    fontSize: 17,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div:first-child': {
      marginBottom: '1em',
    },
  },
  withoutBold: {
    fontWeight: 'normal',
  },
  withoutMarginBottom: {
    marginBottom: '0 !important',
  },
  icon: {
    color: colors.primary,
    fontSize: '5em',
  },
  errorContainer: {
    color: colors.red,
    display: 'flex',
    alignItems: 'center',
    marginTop: 15,
  },
  closeIcon: {
    width: '1em',
  },
  errorIcon: {
    fontWeight: 'bold',
    width: '5em',
    margin: '0',
  },
  errorTitle: {
    fontSize: '0.75em',
    textAlign: 'left',
    fontWeight: 600,
    lineHeight: 1.1,
    fontFamily: fonts.secondary,
  },
  title: {
    fontWeight: 600,
    fontSize: 28,
  },
  tableDivider: {
    width: '70%',
    height: 1,
    marginTop: 'auto',
    marginBottom: 'auto',
    borderBottom: 'none',
    color: colors.greyBlue,
  },
  closeButton: {
    marginTop: '30px',
  },
  downloadButton: {
    marginTop: '30px',
    marginLeft: '24px',
    backgroundColor: '#2F3741',
    color: '#FFFFFF',
    '&:hover': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
    '&:active': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
  },
  downloadModalSubtitle: {
    marginTop: 0,
    fontWeight: 600,
    fontSize: 14,
  },
  errorList: {
    height: 100,
    width: 300,
    overflowY: 'auto',
    overflowX: 'hidden',
    fontWeight: 400,
    fontSize: 14,
  },
  downloadText: {
    marginTop: 16,
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: fonts.secondary,
  },
});
